import React from 'react';
import { Row, Col, Button, Space, Skeleton } from 'antd';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useTranslate } from '/src/lib/MrTranslate/MrTranslate';

const LibraryQuestionbanksLayout = (props) => {
  console.log('CustomExperienceCrudList==>', props)
  const {
    resourceName,
    singleResourceName,
    loading,
    permission,
    currentUser,
    ListHeader,
    config,
    crudListData
  } = props;
  const mrIntl = useTranslate();
  const history = props.history;
  const url = props.match.url;
  const CrudListData = crudListData;
  let customHeaderCreateSearchRender = []
  let showActions = false;
  console.log("permission==>", currentUser.permission);
  const filterConfig = config.filter.config || {};
  const currentUserPermission = currentUser.permission || {};
  const currentUserRole = currentUser.role || "";

  if (filterConfig.actions && filterConfig.actions.show && ((currentUserPermission.manage_permissions && currentUserPermission.manage_permissions.list) || (currentUserRole === "superadmin"))) {
    showActions = true;
  }

  let content = [];

  let createBtn = null;
  
  let totalColWidth = 24;
  
  
  if (
    (permission &&
    permission[singleResourceName] &&
    permission[singleResourceName].create) || true
  ) {
    if(config.list.createBtn.component) {
      createBtn = config.list.createBtn.component;
    } else {
      createBtn = function CreateBtn(parentProps) {
        return null
        //  <CYButton
        //   key={"createBtn"}
        //   type="primary"
        //   onClick={() => history.push(`${url}/create`)}
        //   icon={<PlusOutlined />}
        // >
        //   <FormattedMessage
        //     id="general.create"
        //     defaultMessage={mrIntl("CommonText.create")}
        //   />
        // </CYButton>
      }
    }
    console.log("config.filter", config.filter);
    if(config.filter.config && config.filter.config.create && config.filter.config.create.show) {
      const CreateBtnFinal = createBtn
      customHeaderCreateSearchRender.push(<CreateBtnFinal key="experience-main-create-btn" />)
    }
  }

  const finalFilter =  null;

  const listWrapperWidth = config.filter.style ? config.filter.style.width < 12 ? (totalColWidth - config.filter.style.width) : totalColWidth : totalColWidth;
  
  console.log( "listWrapperWidth - width", listWrapperWidth );
  const list = <CrudListData key={`mainCrudList${resourceName}`} {...props}/>
  let listWrapper = (
    <Col span={listWrapperWidth} key={`mainList${resourceName}Container`}>
      <Row className='custom-main-crud-list-header'>
        <Col span={showActions ? 21 : 24}>
          <Space>
            {customHeaderCreateSearchRender}
          </Space>
        </Col>
      </Row>
      
      <Row>
        {loading ? <>
          {[...Array(3)].map((_, index) => (
            <Skeleton
              className="active-skeleton-loading"
              key={index}
              active
              avatar
              title={true}
              paragraph={{ rows: 2 }}
            />
          ))}
        </> : <>
          {list}
        </>}
      </Row>
    </Col>
  );

  content.push(ListHeader);
  content.push(listWrapper);

  return (<React.Fragment>
      <Row>
        {config.filter.style && config.filter.style.align !== "right" ? finalFilter : null}
        {content}
        {config.filter.style && config.filter.style.align === "right" ? finalFilter : null}
      </Row>
  </React.Fragment>);
};

LibraryQuestionbanksLayout.propTypes = {}
if(import.meta.env.NODE_ENV === 'development'){
  LibraryQuestionbanksLayout.whyDidYouRender = true;
}
export default LibraryQuestionbanksLayout;